import { EventListDataType } from "@src/util/ab-testing/funnel/manage-state-event-lists";
import { formatNumber } from "@src/util/number-format";
import { Typography } from "antd";
import { getColorSignificant, VariantReportToolTip } from "../tooltip-significant";
import { ABExplorationKeyWords } from "@src/constant/ab-testing/ab-testing-exploration.enum";
import { BaseReport } from "../metric-performance/component/metric-performance-item/report-data-v2/variant-report";
import { DataMode } from "@src/util/ab-testing/funnel/maping-funnel-data-source";

export const CellRender: React.FC<{
    uplift_percent?: number;
    significanceLevel: number;
    p_value?: number;
    originRate: number;
}> = ({ uplift_percent, significanceLevel, p_value, originRate }) => {
    const { bg, upliftPercentTextColor } = getColorSignificant({
        significanceLevel: significanceLevel,
        pValue: p_value,
        upliftPercent: uplift_percent,
    });

    return (
        <div className={`custom-cell  px-4 py-4 ${bg} hover:font-bold hover:px-2 duration-100 `}>
            <Typography.Text className="text-black">{formatNumber(originRate * 100) + "%"}</Typography.Text>
            <Typography.Text className="px-2">/</Typography.Text>
            <Typography.Text className={upliftPercentTextColor}>
                {Math.abs((uplift_percent ?? 0) * 100).toFixed(2)}%
            </Typography.Text>
        </div>
    );
};

export const CellRenderWithSignificant: React.FC<{
    significantInfo?: Record<string, any>;
    exp_value: string;
    record: Record<string, any>;
    compareRate: number;
    originRate: number;
    eventLists: EventListDataType[];
    significanceLevel: number;
    getExpAliasById: (expId: string) => string;
    isBaseVariant: boolean;
    mode: DataMode;
    // colorIndex: number;
}> = ({
    significantInfo,
    record,
    exp_value,
    compareRate,
    originRate,
    eventLists,
    significanceLevel,
    getExpAliasById,
    isBaseVariant,
    mode,
    // colorIndex,
}) => {
    if (mode !== "compareWithUserGroup" && originRate) {
        let originTextRender: string | null = (originRate * 100).toFixed(5) + "%";
        if (originRate === -1) originTextRender = "-";
        if (originRate === 1) originTextRender = originRate * 100 + "%";
        return (
            <div
                className={`custom-cell  bg-neutral-100 text-slate-900 h-[50px] flex items-center pl-4 hover:font-bold duration-100`}
            >
                {originTextRender}
            </div>
        );
    }
    const hasSignificant = !!significantInfo;

    if (!hasSignificant) {
        return <div className={`custom-cell bg-neutral-100 text-slate-900 h-[50px] flex items-center`}>-</div>;
    }

    const {
        method,
        p_value,
        mean: mean_variant,
        uplift_percent,
        lower_bound_uplift_percent,
        upper_bound_uplift_percent,
        error_message,
        [ABExplorationKeyWords.SAMPLE_SIZE]: sampleSize,
    } = significantInfo;
    const { bg, upliftPercentTextColor } = getColorSignificant({
        significanceLevel: significanceLevel,
        pValue: p_value,
        upliftPercent: uplift_percent,
    });
    if (isBaseVariant) {
        return (
            <div className="custom-cell">
                <BaseReport
                    measureType="proportion"
                    mean={mean_variant}
                    pValue={p_value}
                    upliftPercent={uplift_percent}
                    sampleSize={sampleSize}
                    colorFn={() => ({
                        bg,
                        upliftPercentTextColor,
                    })}
                />
            </div>
        );
    }
    return (
        <VariantReportToolTip
            groupAlias={getExpAliasById(exp_value)}
            report={{
                method,
                p_value,
                mean: mean_variant,
                uplift_percent,
                lower_bound_uplift_percent,
                upper_bound_uplift_percent,
                error_message,
                [ABExplorationKeyWords.SAMPLE_SIZE]: sampleSize,
            }}
            significanceLevel={significanceLevel}
        >
            <div className="custom-cell">
                <BaseReport
                    measureType="proportion"
                    mean={mean_variant}
                    pValue={p_value}
                    upliftPercent={uplift_percent}
                    sampleSize={sampleSize}
                    colorFn={() => ({
                        bg,
                        upliftPercentTextColor,
                    })}
                />
            </div>
        </VariantReportToolTip>
    );
};
